import { runInInjectionContext, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
type StepOptions = Shepherd.Step.StepOptions;
import { commonConfig, waitForElement } from './utils';

export function getNotificationsTourMobileSteps(injector: Injector): StepOptions[] {
  return runInInjectionContext(injector, () => {
    const router = inject(Router);
    return [
      {
        id: 'Notifications-step-mobile-01',
        title: 'Manage your Email Alerts',
        text: 'Click here to access and manage your alert settings.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#NotificationsMobileStep1',
          on: 'bottom-end' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/settings/alerts']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Notifications-step-mobile-02',
        title: 'Review your email alerting setup',
        text: 'All your alerts.  Each configuration delivers a tailored email digest of our latest relevant publications directly to your mailbox.  Create your own custom alerts, daily, weekly, or even daily split, on specific subjects you want to monitor.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#NotificationsStep2',
          on: 'top' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#NotificationsStep2').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Notifications-step-mobile-03',
        title: 'Create New Alert',
        text: 'To establish a new email alerting configuration, select this button to begin the configuration process.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#NotificationsStep3',
          on: 'top' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Notifications-step-mobile-04',
        title: 'Remove Notification',
        text: 'To remove one of your alerting configuration, use this button. It will permanently delete it from your profile.',
        classes: 'shepherd-custom shepherd-custom-left-position',
        attachTo: {
          element: '#NotificationsStep5_0',
          on: 'left' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#NotificationsStep5_0').then(() => {
              setTimeout(() => {
                resolve();
              }, 300);
            });
          });
        },
        buttons: [
          {
            text: 'Finish',
            action() {
              this.complete();
              router.navigate(['/site/help']);
            }
          }
        ]
      }
    ];
  });
}